/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRectangleRoundedBottom = createReactComponent(
  "rectangle-rounded-bottom",
  "IconRectangleRoundedBottom",
  [
    [
      "path",
      {
        d: "M9 18h6a6 6 0 0 0 6 -6v-5a1 1 0 0 0 -1 -1h-16a1 1 0 0 0 -1 1v5a6 6 0 0 0 6 6z",
        key: "svg-0"
      }
    ]
  ]
);

export { IconRectangleRoundedBottom as default };
//# sourceMappingURL=IconRectangleRoundedBottom.js.map
